"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroup = exports.Button = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./Button.sass");

var _Icons = require("../Icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Button = function Button(_ref) {
  var _cn;

  var _ref$success = _ref.success,
      success = _ref$success === void 0 ? false : _ref$success,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === void 0 ? false : _ref$transparent,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$gosUslugi = _ref.gosUslugi,
      gosUslugi = _ref$gosUslugi === void 0 ? false : _ref$gosUslugi,
      _ref$add = _ref.add,
      add = _ref$add === void 0 ? false : _ref$add,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? false : _ref$text,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'normal' : _ref$size,
      children = _ref.children,
      onClick = _ref.onClick,
      className = _ref.className,
      style = _ref.style,
      ref = _ref.ref,
      silver = _ref.silver,
      type = _ref.type;
  var mainClassName = add ? 'sber-btn-add' : 'sber-btn';
  return /*#__PURE__*/_react.default.createElement("button", {
    ref: ref,
    style: style,
    disabled: disabled,
    type: type,
    className: (0, _classnames.default)(mainClassName, className, (_cn = {}, _defineProperty(_cn, "".concat(mainClassName, "--success"), success), _defineProperty(_cn, "".concat(mainClassName, "--transparent"), transparent), _defineProperty(_cn, "".concat(mainClassName, "--transparent ").concat(mainClassName, "--transparent-silver"), transparent && silver), _defineProperty(_cn, "".concat(mainClassName, "--text"), text), _defineProperty(_cn, "".concat(mainClassName, "--gosUslugi"), gosUslugi), _defineProperty(_cn, "".concat(mainClassName, "--large"), size === 'large'), _defineProperty(_cn, "".concat(mainClassName, "--small"), size === 'small'), _cn)),
    onClick: onClick
  }, add ? /*#__PURE__*/_react.default.createElement("span", {
    className: "sber-add-btn-container"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sber-add-btn-container__text"
  }, children), /*#__PURE__*/_react.default.createElement("span", {
    className: "sber-add-btn-container__icon"
  }, /*#__PURE__*/_react.default.createElement(_Icons.PlusIcon, {
    size: 16,
    color: "#21A038"
  }))) : children);
};

exports.Button = Button;
Button.propTypes = {
  success: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  transparent: _propTypes.default.bool,
  gosUslugi: _propTypes.default.bool,
  silver: _propTypes.default.bool,
  add: _propTypes.default.bool,
  text: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['small', 'normal', 'large']),
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  onClick: _propTypes.default.func,
  className: _propTypes.default.string,
  type: _propTypes.default.oneOf(['button', 'submit'])
};

var ButtonGroup = function ButtonGroup(_ref2) {
  var children = _ref2.children,
      className = _ref2.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    role: "group",
    "aria-label": "button group",
    className: (0, _classnames.default)('sber-btn-group', className)
  }, children);
};

exports.ButtonGroup = ButtonGroup;
ButtonGroup.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  className: _propTypes.default.string.isRequired
};